import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './authorize.service';

/**
 * Lässt die Feld-Sicht "Meine Einsätze" (Ticketsystem) für alle Personen vor Ort zu
 * (Vorarbeiter, Bauleiter, Montage) – unabhängig davon, ob sie die Stammkunden-
 * Verwaltung betreten dürfen. So sieht der reine Vorarbeiter das Ticketsystem,
 * ohne Zugriff auf die Verwaltung zu haben.
 */
@Injectable({ providedIn: 'root' })
export class MeineEinsaetzeGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(): boolean {
    if (this.authService.isAuthenticated() && this.authService.canSeeMeineEinsaetze()) {
      return true;
    }
    this.router.navigate(['/home']);
    return false;
  }
}
